import { h } from "omi";

export function SaveIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
      <path
        d="M3.5 1.5v1.7c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C3.88 4 4.02 4 4.3 4h3.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C8.5 3.62 8.5 3.48 8.5 3.2V2m0 8.5V7.3c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C8.12 6.5 7.98 6.5 7.7 6.5H4.3c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C3.5 6.88 3.5 7.02 3.5 7.3v3.2m7-5.8373V8.1c0 .84 0 1.2601-.1635 1.581a1.4999 1.4999 0 0 1-.6555.6555C9.36 10.5 8.94 10.5 8.1 10.5H3.9c-.84 0-1.2601 0-1.581-.1635a1.5 1.5 0 0 1-.6555-.6555C1.5 9.36 1.5 8.94 1.5 8.1V3.9c0-.84 0-1.2601.1635-1.581a1.5 1.5 0 0 1 .6555-.6555C2.64 1.5 3.06 1.5 3.9 1.5h3.4373c.2446 0 .3668 0 .482.0276a1 1 0 0 1 .289.1198c.1009.0618.1874.1483.3603.3212l1.5628 1.5628c.1729.173.2594.2594.3212.3603a.9982.9982 0 0 1 .1198.289c.0276.1152.0276.2374.0276.482Z"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
